import type { HTMLAttributes } from "react";
import { cn } from "../../utils/cn";

export function AppleIcon({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("w-auto h-auto aspect-[911/1120]", className)}
      {...props}>
      <svg width="100%" height="100%" viewBox="0 0 911 1120">
        <title>Apple Icon</title>
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <path
            d="M882.462651,382.117647 C807.826506,428.235294 761.727711,507.294118 761.727711,595.137255 C761.727711,693.960784 820.99759,784 911,821.333333 C893.438554,878.431373 867.096386,931.137255 834.168675,979.45098 C785.874699,1047.52941 735.385542,1117.80392 660.749398,1117.80392 C586.113253,1117.80392 564.161446,1073.88235 476.354217,1073.88235 C390.742169,1073.88235 360.009639,1120 289.763855,1120 C219.518072,1120 171.224096,1056.31373 116.344578,977.254902 C43.9036145,867.45098 2.19518072,740.078431 0,606.117647 C0,388.705882 140.491566,272.313725 280.983133,272.313725 C355.619277,272.313725 417.084337,320.627451 463.183133,320.627451 C507.086747,320.627451 577.33253,270.117647 660.749398,270.117647 C748.556627,267.921569 831.973494,309.647059 882.462651,382.117647 Z M621.236145,177.882353 C658.554217,133.960784 678.310843,79.0588235 680.506024,21.9607843 C680.506024,15.372549 680.506024,6.58823529 678.310843,0 C614.650602,6.58823529 555.380723,37.3333333 513.672289,85.6470588 C476.354217,127.372549 454.40241,180.078431 452.207229,237.176471 C452.207229,243.764706 452.207229,250.352941 454.40241,256.941176 C458.792771,256.941176 465.378313,259.137255 469.768675,259.137255 C529.038554,254.745098 583.918072,224 621.236145,177.882353 Z"
            fill="currentColor"
            fillRule="nonzero"></path>
        </g>
      </svg>
    </div>
  );
}
